/**
 * ボタン（docs/06 4-1）。
 *
 * 決めごと:
 *  - **押せるところは 44px 四方以上**（docs/06 6-2）
 *  - 処理中は字を「〜しています…」に変えて、二度押しできないようにする（docs/06 原則2）
 *  - 色は書かない。見た目の種類（主役・控え・静か・危険）で選ぶ
 */
import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'quiet' | 'danger';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  /** 見た目の種類。主役は1画面に1つが目安 */
  variant?: ButtonVariant;
  /** 処理中（押せなくなり、字が busyLabel に変わる） */
  busy?: boolean;
  /** 処理中に出す言葉 */
  busyLabel?: string;
  /** 一覧の中などで使う小さめの見た目（押せる大きさは 44px を保つ） */
  compact?: boolean;
  /** 開いた直後にここへ合わせたいときに使う（確認の窓など） */
  ref?: Ref<HTMLButtonElement>;
  children: ReactNode;
}

export function Button({
  variant = 'secondary',
  busy = false,
  busyLabel = '処理中…',
  compact = false,
  type = 'button',
  disabled,
  children,
  ...rest
}: ButtonProps): ReactNode {
  return (
    <button
      {...rest}
      type={type}
      className={`ui-button ui-button-${variant}${compact ? ' ui-button-compact' : ''}`}
      disabled={disabled === true || busy}
      aria-busy={busy ? 'true' : undefined}
    >
      {busy ? busyLabel : children}
    </button>
  );
}
